$ = require 'jquery'
Browser = require '@trello/browser'
CardView = require 'app/scripts/views/card/card-view'
CollectionView = require 'app/scripts/views/internal/collection-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
PostRender = require 'app/scripts/views/lib/post-render'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
{ chunkArray } = require './chunkArray'
log = require 'app/scripts/debug/log'
Promise = require 'bluebird'
f = require 'effing'

# I know, I know. IE masks it's user agent and this is as close as we get.
# We’re “jostling” the board to trigger a redraw which will ensure
# .list-cards is correctly sized. It will otherwise overflow the list.
# We need to do this after the cards are rendered.
jostle =
  if !(Browser.browserStr in ['chrome', 'firefox', 'opera']) && Browser.osStr == "windows"
    _.debounce ->
      PostRender.enqueue "jostleBoard", ->
        $('#board').css('bottom', 1)
        _.defer ->
          $('#board').css('bottom', 0)
  else
    ->

module.exports = class CardListView extends CollectionView
  viewType: CardView

  getModels: -> @collection.models

  constructor: ->
    super

    @debouncedRefreshIfInitialized = @debounce(@refreshIfInitialized, 10)

  render: ->
    log('render', "rendering #{@getModels().length} #{@collection.model.name}s into #{@viewType.name}")

    if @options.deferCards
      # If our whole list is not initial visible, wait to render any of
      # these cards
      PostRender.enqueue "deferredCardList_#{ @cid }", =>
        @progressiveRender()
    else
      @progressiveRender()

    @

  progressiveRender: ->
    allModels = @getModels()

    append = (models) =>
      @appendSubviews(@subview(@viewType, model) for model in models)

    maxVisibleCards = Math.max(10, Math.ceil(window.innerHeight / 32)) # Hard-coded minimum card height
    visible = _.first(allModels, maxVisibleCards)
    append(visible)

    chunks = chunkArray(_.rest(allModels, maxVisibleCards), maxVisibleCards)
    chunks.forEach (chunked, index) =>
      PostRender.enqueue "deferredHiddenCards_#{ @cid }_chunk#{ index }", =>
        append(chunked)
        jostle()

  insertSubview: (subview, target, $el = @$el) ->
    log('render', "inserting #{ subview.$el.find('h2').text() } at position #{ target }")
    # Turn target from an index or a view into an element
    if typeof target == "number"
      if target <= 0
        target = $el.children().eq(0)
      else if target < $el.children().length
        target = $el.children().eq(target)
      else
        target = undefined
    else if target instanceof View
      target = target.$el

    card = subview.model

    if subview.$el.is(':empty')
      # If the subview is empty then it needs to be rendered.
      subview.delegateEvents()
      subview.render()
    else if !$el.hasClass('hide') && !card.getBoard().filter.satisfiesFilter(card)
      # If the subview is rendered but meant to be filtered, then call renderFiltered()
      subview.renderFiltered()

    if target?.length > 0
      subview.$el.insertBefore(target)
    else
      $el.append(subview.$el)

    @debouncedRefreshIfInitialized()

  refreshIfInitialized: ->
    DragSort.refreshIfInitialized(@$el)

  scrollToCardView: (card) ->
    cardSubview = @viewForModel(card)
    if cardSubview
      cardSubviewElement = cardSubview.$el[0]
      @$el.scrollTop(cardSubviewElement.offsetTop + cardSubviewElement.offsetHeight)
